export default __webpack_public_path__ + "static/Corprate_US_Internships_03-07e9f50b9f39132f4d49de162fcb4e4f.jpg";